import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import { apolloProvider } from './graphql/apollo'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import VueTruncate from 'vue-truncate-filter'
import VueApexCharts from 'vue-apexcharts'
import Trend from 'vuetrend'
import VueMoment from 'vue-moment'
import LoadScript from 'vue-plugin-load-script'
import infiniteScroll from 'vue-infinite-scroll'
import VueMultianalytics from 'vue-multianalytics'
import VueAmplitude from 'vue-amplitude'

Vue.use(Trend)
Vue.use(Buefy)
Vue.use(VueTruncate)
Vue.use(VueMoment)
Vue.component('v-select', vSelect)
Vue.component('apexchart', VueApexCharts)
Vue.use(LoadScript)
Vue.use(infiniteScroll)

let gaConfig = {
  appName: process.env.VUE_APP_GA_APP_NAME,
  appVersion: process.env.VUE_APP_GA_APP_VERSION,
  trackingId: process.env.VUE_APP_GA_TRACKING_ID
}

Vue.use(VueMultianalytics, {
  modules: {
    ga: gaConfig
  }
})

Vue.use(VueAmplitude, {
  apiKey: process.env.VUE_APP_AMPLITUDE_API_KEY
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  apolloProvider
}).$mount('#app')
